$(function() {
	function dateShortString(date) {
		return $.fn.datepicker.DPGlobal.formatDate(date, 'yymmdd', 'en');
	}

	function createUTC(date) {
		var x = new Date(date);
		x.setTime(x.getTime() + x.getTimezoneOffset() * 60000);
		return x;
	}

	window.arrivalDateSet = function() {
		var arrivalDate = $('#availability-options div.month').datepicker('getUTCDate');
		return arrivalDate && !isNaN(arrivalDate);
	};

	function updateDateDisplay() {
		var arrivalDate, flexible, flexibleString;
		arrivalDate = $('#availability-options div.month').first().datepicker('getUTCDate');
		if (arrivalDate && !isNaN(arrivalDate)) {
			flexible = parseInt($('.filter_flexible').val());
			flexibleString = flexible && flexible > 0 ? " +/- " + flexible : "";

			var dpLang = ($.fn.datepicker.dates[selectedLanguage]
				? selectedLanguage
				: (selectedLanguage && selectedLanguage.indexOf('-') > -1
					? selectedLanguage.split('-')[0]
					: selectedLanguage));
			if (!$.fn.datepicker.dates[dpLang]) { dpLang = 'en'; }

			// Update the filter button group title
			$('#availability-options .month').parents('.filter.btn-group').find('.title').html("" + ($.fn.datepicker.DPGlobal.formatDate(arrivalDate, 'd M yyyy', dpLang)) + flexibleString);

			// Update the arrival date input field value
			var arrivalDateInput = $('.js-desktop-search-input-arrival');
			if (arrivalDateInput.length > 0) {
				var formattedDate = $.fn.datepicker.DPGlobal.formatDate(arrivalDate, 'd M yyyy', dpLang) + flexibleString;
				arrivalDateInput.val(formattedDate);
			}

			highlightDuration('#availability-options .datepicker .day.active');
		}
	}

	var highlightDuration, highlightDurationForActive, shiftDestinationOptions, unhighlightDuration;

	$('.filter-reset a').click(function() {
		var title;
		title = $(this).parents('.filter.btn-group').find('.title');
		return title.html(title.data('default'));
	});

	shiftDestinationOptions = function() {
		var dest = $('#destinations-options');
		if ($(window).width() > 700 && !dest.data('no-shift')) {
			dest.css('left', Math.min(0, 470 - dest.outerWidth()));
		} else {
			dest.css('left', 0);
		}
		dest.css('visibility', '');

		$('#filters #destination-input').focus();
	};
	$('#filters #destinations').click(function() {

		$('#destinations-options').css('visibility', 'hidden');
		return setTimeout(shiftDestinationOptions, 1);
	});
	$('#filters #destination-input').click(function() {
		return false;
	});
	highlightDuration = function(el) {
		var $days, elIndex, highlightedDays, tailLength;
		tailLength = parseInt($('.filter_flexible').val());

		if ($(el).length && tailLength) {
			$days = $('.day');
			elIndex = $days.index($(el));
			highlightedDays = $.grep($days, function(dayElement, index) {
				return (index <= elIndex + tailLength) && (index >= elIndex - tailLength) && !$(dayElement).hasClass('disabled');
			});
			return $(highlightedDays).addClass('highlight');
		}
	};

	highlightDurationForActive = function() {
		return highlightDuration('#availability-options .datepicker .day.active');
	};

	unhighlightDuration = function() {
		return $(".day.highlight").removeClass('highlight');
	};

	highlightDuration('.public .datepicker .day.active');

	function decompressDates(compressed) {
		if (!compressed)
			return null;

		var dates = {};
		var codes = compressed.toString().split(",");
		var date;

		for (var index in codes) {
			var code = codes[index];
			var frags = code.split("-");
			var count = (frags.length > 1) ? parseInt(frags[1]) : 1;
			code = frags[0];

			if (index > 0) {
				date.setDate(date.getDate() + parseInt(code.slice(0, 4)));
			} else {
				date = new Date(0);
				date.setUTCFullYear(parseInt(code.slice(0, 2)) + 2000);
				date.setUTCMonth(parseInt(code.slice(2, 4))-1);
				date.setUTCDate(parseInt(code.slice(4, 6)));
			}

			for (var i = 0; i < count; ++i) {
				dates[dateShortString(createUTC(date))] = true;
				date.setDate(date.getDate() + 1);
			}
		}

		return dates;
	}

	var av = decompressDates($('#availability-options .month').data('availability'));

	$('.filter_flexible').on('change', function(){
		monthSelection();
	});

	$('#availability-options .month').datepicker({
		language: selectedLanguage,
		format: "yyyy-mm-dd",
		weekStart: 1,
		beforeShowDay: function(date) {
			var probe = dateShortString(createUTC(date));
			if (av[probe]) {
				return 'available';
			} else {
				return false;
			}
		}
	}).on('changeDate', function(event) {
		updateDateDisplay();

		var arrivalDate, arrivalDateString, sortingParam = '';
		arrivalDate = $(this).datepicker('getUTCDate');
		arrivalDateString =  $.prototype.datepicker.DPGlobal.formatDate(arrivalDate, 'yyyy-mm-dd', 'en');

		if (arrivalDate && !isNaN(arrivalDate)) {
			var query = window.location.search;
			query = updateQueryStringParameter(query, "arrival_date", arrivalDateString);
			query = updateQueryStringParameter(query, "flexible", ($('.filter_flexible').val()));
			query = removeQueryStringParameter(query, "page");

			if($(event.target).closest('#js-forced-dates').length) {
				let a = document.querySelector('.search__modal--arrival-duration');
				a.classList.remove('hide');
				// Add the date to the url without reloading the page
				window.history.pushState({},"", query);
			} else {
				let arrivalDate = document.querySelectorAll('.landing-search__calendar .month');
				let viewAllElm = document.querySelector('.sector-view-all');
				let viewAllUrl = '';
				if (arrivalDate.length !== 0 && viewAllElm && typeof viewAllElm.getAttribute === 'function') {
					viewAllUrl = viewAllElm.getAttribute('href');
					let params = query.replace(/^\?/, '');
					let sep = (viewAllUrl.indexOf('?') !== -1) ? '&' : '?';
					let newUrl = `${viewAllUrl}${sep}${params}`;
					// Store date query globally for experiment combined redirect
					try { window.__expSrParamDateQuery = '?' + params; } catch(e) {}
					// Experiment guard: prevent redirect on date clicks, log intended URL instead (not on /sr)
					if ($('.landing-search').attr('id') === 'new-landing-search' && window.location.pathname.indexOf('/sr') !== 0) {
                        try { gae('search_hero', 'tp_modal_arrival-link'); } catch(e) {}
						console.log('🎯 [DATE CLICK] would redirect to:', newUrl);
						return;
					}
					window.location.href = newUrl;
				}
				else {
				if(window.location.pathname == '/') {
					// Store date query globally for experiment combined redirect
					try { window.__expSrParamDateQuery = query; } catch(e) {}
					// Experiment guard: prevent redirect on date clicks, log intended URL instead (not on /sr)
					if ($('.landing-search').attr('id') === 'new-landing-search' && window.location.pathname.indexOf('/sr') !== 0) {
                        try { gae('search_hero', 'tp_modal_arrival-link'); } catch(e) {}
						console.log('🎯 [DATE CLICK] would redirect to:', `/sr${query}`);
						return;
					}
					window.location.href = `/sr${query}`;
				}
				else {
					// Store date query globally for experiment combined redirect
					try { window.__expSrParamDateQuery = query; } catch(e) {}
					// Experiment guard: prevent redirect on date clicks, log intended URL instead (not on /sr)
					if ($('.landing-search').attr('id') === 'new-landing-search' && window.location.pathname.indexOf('/sr') !== 0) {
                        try { gae('search_hero', 'tp_modal_arrival-link'); } catch(e) {}
						console.log('🎯 [DATE CLICK] would redirect to:', window.location.pathname + query);
						return;
					}
					window.location.search = query;
				}
				}
			}
		}

	}).on('changeMonth', function(event) {
		return setTimeout(highlightDurationForActive, 1);
	});
	$('#availability-options .search').on('click', function(event) {
		var arrivalDate, arrivalDateString, sortingParam = '';
		arrivalDate = $('#availability-options div.month').datepicker('getUTCDate');
		arrivalDateString = $.fn.datepicker.DPGlobal.formatDate(arrivalDate, 'yyyy-mm-dd', 'en');
		if (arrivalDate && !isNaN(arrivalDate)) {
			var query = window.location.search;
			query = updateQueryStringParameter(query, "arrival_date", arrivalDateString);
			query = updateQueryStringParameter(query, "flexible", ($('.filter_flexible').val()));
			query = removeQueryStringParameter(query, "page");
			window.location.search = query;
		}
		return $('#availability-options div.month').trigger('click.dropdown.data-api');
	});
	$('#availability-options').on('click', function(event) {
		console.log("click stop propagation");
		return event.stopPropagation();
	});
	$('#available-dates').on('click', function(event) {
		monthSelection();
		$('#availability-options .search').hide();
	});
	$('#availability-options .datepicker').on('mouseover.duration', '.available', function() {
		unhighlightDuration();
		return highlightDuration(this);
	}).on('mouseout.duration', '.available', function() {
		unhighlightDuration();
		return highlightDuration('#availability-options .datepicker .day.active');
	});
	return $('#availability-options select').on('change', function() {
		unhighlightDuration();
		updateDateDisplay();

		var arrivalDate = $('#availability-options div.month').datepicker('getUTCDate');
		if (arrivalDate && !isNaN(arrivalDate)) {
			return $('#availability-options .search').click();
		}
	});
});

function monthSelection(){
	var ffval = $('.filter_flexible').val();
	if(ffval == 15){
		$('.datepicker-inline > div').hide();
		$('.datepicker-inline .datepicker-months').show();
		$('.datepicker-inline .datepicker-months thead th').css('opacity','0');
		$('.datepicker-inline .datepicker-months thead th.datepicker-switch').css('opacity','1');
		$('.datepicker-inline .datepicker-months thead').css('pointer-events','none');
		$('.datepicker-inline .datepicker-months span').on('click',function(){
			setTimeout(function(){
				var d = 15;
				while($('td:contains("'+d+'")').hasClass('disabled')){d++;};
				$('td:contains("'+d+'")').trigger('click');
				$('#availability-options').hide();
			},1);
		});
	}else{
		$('.datepicker-inline > div').hide();
		$('.datepicker-inline .datepicker-days').show();
	};
};

$(function() {
	var getParam = function (sParam) {
		var sPageURL = decodeURIComponent(window.location.search.substring(1)),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;
		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');
			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : sParameterName[1];
			}
		}
	};

	var arrival_date = getParam('arrival_date');
	if(typeof(arrival_date) != 'undefined'){
		$('.filter_flexible').change(function(e){
			window.filter_flexible_timeout = setTimeout(function(){
				var query = window.location.search;
				var value;
				if(e.target.id == 'filter_flexible--sidebar') {
					value = e.target.value;
				}
				else {
					value = $('.filter_flexible').val();
				}
				query = updateQueryStringParameter(query, "flexible", (value));
				window.location.search = query;
			},1000);
			$('.datepicker *').click(function(){
				clearInterval(window.filter_flexible_timeout);
			});
		})
	};
})
